// extracted by mini-css-extract-plugin
export default {"steps":"CSTEClub_steps__8D8O7","step":"CSTEClub_step__oXtoj"};